import React from 'react';
import '../style/footer.css'; 
// Import the necessary icons from react-icons/fa
import { FaFacebookF, FaInstagram } from 'react-icons/fa'; 

// You would replace this with the actual path to your logo image
import PaRM_Logo from '../parm_assets/parm_logo.png'; 

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Section 1: Logo and Association Name */}
        <div className="footer-section footer-logo-social">
          <div className="logo-group">
            <img src="https://ik.imagekit.io/axiomhives/parm_assets/Logo%20-%20PARM%20ISA%20Malaysia%20Chapter%20(Putih).png" alt="PaRM Logo" className="footer-logo" />
            <h3 className="association-name">Persatuan Arborist Malaysia (PArM)</h3>
          </div>

          {/* Social Media - NOW WITH REACT ICONS */}
          <div className="social-media">
            <h4>Social Media</h4>
            <div className="social-icons">
              <a 
                href="https://www.facebook.com/PersatuanArboristMalaysia/?locale=ms_MY" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook" // Accessibility improvement
              >
                <FaFacebookF /> 
              </a>
              <a 
                href="https://www.instagram.com/parmmalaysia/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram" // Accessibility improvement
              >
                <FaInstagram /> 
              </a>
            </div>
          </div>
        </div>

        {/* Section 2: Address and Contact */}
        <div className="footer-section footer-contact-info">
          <h4>Address</h4>
          <p>PERSATUAN ARBORIST MALAYSIA (PArM)</p>
          <p>D2-03-25</p>
          <p>ATELIER CENTRE</p>
          <p>BLOK D2, JALAN ATELIER 3</p>
          <p>EDUSPHERE, CYBER 11</p>
          <p>63000 CYBERJAYA</p>
          <p>SELANGOR</p>

          <h4>Contact No.</h4>
          <p>Phone: +60 16‑329 9313 (Ms. Izati Shara)</p>
          <p>Phone: +60 17-666 9725 (Ms. Fairuz)</p>
        </div>

        {/* Section 3: Email and Subscription */}
        <div className="footer-section footer-email-subscribe">
          <h4>Email Address</h4>
          <p>malaysiaarborist@gmail.com</p>

          <form className="subscribe-form"
          action="mailto:malaysiaarborist@gmail.com" 
          method="post" 
          enctype="text/plain"
          >
            <input type="email" placeholder="Type your email" className="email-input" />
            <button type="submit" className="submit-button" aria-label="Subscribe">
              <span className="submit-arrow">➤</span>
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Footer Bar */}
      <div className="footer-bottom">
        <p>©2026 Malaysian Society Of Arborist | All Rights Reserved</p>
        <div className="footer-links">
          {/* <a href="/terms">Terms & Condition</a>
          <a href="/privacy">Privacy Policy</a> */}
          <a href="/contact">Contact Us</a>

          <a href="/archive-timeline-parm">Archive</a>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;